var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.85 31.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-D7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1298129567840",
    "data-name": 1298129567840
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.68,18.44h1.56a.19.19,0,0,1,0,.12.48.48,0,0,0,.05.12c.35,1.17.72,3.24,3,3.29a3.1,3.1,0,0,0,2.86-2.12l.39-1.41h1.56c.16.29.49,3.83,3.5,3.51s3.74-4.94,1.25-6.58a4.57,4.57,0,0,0-2.8-.51H7a5.55,5.55,0,0,0-2.88.41,3.3,3.3,0,0,0-1.54,2.16,3.58,3.58,0,0,0,2.49,4.5,3,3,0,0,0,3.2-2,4.37,4.37,0,0,0,.19-.67c.05-.22,0-.13.08-.37l0-.12.12-.36Zm6-6.46c-.08-.16-.07.12-.13-.46,0,0,0-.39,0-.46l0-3.16L11,7.88V12c-2,.11-5.61-.31-7.29.34A6.15,6.15,0,0,0,.14,17a6.85,6.85,0,0,0,2,6.38c.58.6.35,2.43.35,4a44.16,44.16,0,0,0,0,4.47H24.29c.19-1.06.12-5.23.11-6.75,0-1-.17-1.25.42-1.82,3.65-3.51,2.08-10.18-2.38-11.18-2-.44-6.3.3-7.75-.17Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,0a33.81,33.81,0,0,1-1.59,3.39c-.65,1.73,0,3,1.62,2.94C16.05,6.21,14.13.76,12.8,0Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD7);
export default __webpack_public_path__ + "static/media/D7.4930b192d4172d19453aee49e031bd1a.svg";
export { ForwardRef as ReactComponent };